import { CombinedError } from 'urql';
import 'react';
import '@tanstack/react-query';
import 'lodash-es';

/**
 * Error thrown when a fetch call returns a 401.
 */ class NotAuthenticatedError extends Error {
    constructor(response){
        super('Not authenticated');
        this.response = response;
        Object.setPrototypeOf(this, NotAuthenticatedError.prototype);
    }
}
function isNotAuthenticatedError(error) {
    return /* useFetch throws NotAuthenticatedError */ error instanceof NotAuthenticatedError || /* urql throws CombinedError with not auth message */ error instanceof CombinedError && error.message === '[Network] Not authenticated';
}

export { NotAuthenticatedError, isNotAuthenticatedError };
//# sourceMappingURL=NotAuthenticatedError.js.map
